import SmartPidTab from "./SmartPidTab";
import Digital3dModelingTab from "./Digital3dModelingTab";
import DitMaintenanceSystemTab from "./DitMaintenanceSystemTab";

/** Must match tab labels and list column links (hash `ams` param). */
export const AMS_TAB_TITLE_SMART_PID = "Projects";
export const AMS_TAB_TITLE_REALTIME = "Realtime Plant Data";
export const AMS_TAB_TITLE_MAINTENANCE = "Maintenance Management System";

export const amsTabs = (reRender, projectId) => [
  {
    title: AMS_TAB_TITLE_MAINTENANCE,
    panel: <DitMaintenanceSystemTab projectId={projectId} />,
  },
  {
    title: AMS_TAB_TITLE_REALTIME,
    panel: <Digital3dModelingTab />,
  },

  {
    title: AMS_TAB_TITLE_SMART_PID,
    panel: <SmartPidTab reRender={reRender} />,
  },
];
